// extracted by mini-css-extract-plugin
module.exports = {"alert":"Cartel_alert__2VOHN","container":"Cartel_container__2F1iC","msg":"Cartel_msg__wgtNc","button":"Cartel_button__3krkb","aux":"Cartel_aux__2PanW"};